import * as firebase from 'firebase/app';
import firebaseConfig from './config';

console.log("Initializing Firebase");
firebase.initializeApp(firebaseConfig);
export default firebase;
